import { TextField, Box, TextFieldProps } from "@mui/material";
import React from "react";
import { styled } from "@mui/system";
import { colors, fontFamilies } from "~/theme";
import { H5 } from "~/features/typography";

const StyledTextField = styled(TextField)({
    "& .MuiFilledInput-underline:before": {
        display: "none",
    },
    "& .MuiFilledInput-underline:after": {
        display: "none",
    },

    "& .MuiFilledInput-root": {
        borderRadius: "8px",
        backgroundColor: colors.black03,
        minHeight: "56px",
    },

    "& .Mui-error .MuiFilledInput-input": {
        color: colors.redDark,
    },

    "& .MuiFilledInput-root.Mui-error": {
        backgroundColor: colors.red05,
    },

    "& .MuiFilledInput-input": {
        padding: "16px 12px",
        fontFamily: fontFamilies.hurme2,
        fontWeight: 400,
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.15px",
        color: colors.black,
    },

    "& .MuiFormLabel-root": {
        display: "none",
    },

    "& div.MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)":
        {
            marginTop: 0,
        },
});

export function TextInputLabel({
    children,
    mobile,
}: React.PropsWithChildren<{ mobile?: boolean }>) {
    return (
        <Box marginBottom="8px">
            <H5 mobile={mobile}>{children}</H5>
        </Box>
    );
}

export function TextInput({
    label,
    mobile,
    ...props
}: TextFieldProps & { mobile?: boolean }) {
    return (
        <Box>
            {label && <TextInputLabel mobile={mobile}>{label}</TextInputLabel>}
            <StyledTextField
                label={label}
                variant="filled"
                maxRows={6}
                {...props}
            />
        </Box>
    );
}
